import { format } from "date-fns";
import flowRight from "lodash/flowRight";
import moment from "moment";
import formField from "pages/forms/_components/_fields/_commons/formField";
import DatePicker from "pages/_components/fields/datepicker";
import withFocus from "pages/_components/withFocus";
import { bool, func, string } from "prop-types";
import React, { Component } from "react";
import { get } from "util/config";
import * as i18n from "util/i18n";

class Date extends Component {
    static propTypes = {
        dateFormat: string.isRequired,
        editing: bool.isRequired,
        setValue: func.isRequired,
        name: string.isRequired,
        onBlur: func.isRequired,
        placeholder: string.isRequired,
        toggleIsFocused: func.isRequired,
        value: string.isRequired,
        startDate: string.isRequired,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            ...prevState,
            startDate: nextProps.value ? moment(nextProps.value) : null,
        };
    }

    constructor(props) {
        super(props);

        this.state = {};
    }

    handleDateChange = (date) => {
        const { setValue } = this.props;
        setValue(date);
    };

    render() {
        const {
            name,
            value,
            editing,
            dateFormat,
            toggleIsFocused,
            placeholder,
            onBlur,
            startDate,
            ...rest
        } = this.props;

        if (editing) {
            return (
                <div
                    className="input-group input-group-datepicker full-width"
                    onFocus={toggleIsFocused}
                    onBlur={toggleIsFocused}>
                    <DatePicker
                        className="form-control"
                        selected={moment(new Date())}
                        showYearDropdown
                        scrollableYearDropdown
                        onChange={this.handleDateChange}
                        {...rest}
                    />
                </div>
            );
        }

        return (
            <span>
                {value
                    ? format(value, dateFormat || get("frontend.shortDateFormat").toUpperCase())
                    : i18n.get("datepicker.noDate")}
            </span>
        );
    }
}

export default flowRight(withFocus, formField({ formClass: "form-group--datepicker" }))(Date);
